/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PurchaseOrdersUuidDocumentFileKeyGet$Params {
  uuid: string;
  fileKey: string;
}

export function purchaseOrdersUuidDocumentFileKeyGet(http: HttpClient, rootUrl: string, params: PurchaseOrdersUuidDocumentFileKeyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, purchaseOrdersUuidDocumentFileKeyGet.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('fileKey', params.fileKey, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

purchaseOrdersUuidDocumentFileKeyGet.PATH = '/purchase-orders/{uuid}/document/{fileKey}';
